var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { EventEmitter } from 'events';
import loadJs from '../common/loadjs';
import { AppJsApi } from '../common/config';
import { createDeeplink } from '../common/scheme';
import Plat from '../common/plat';
import { errorLogger, debugLogger } from '../../debug';
import { AppDownloadStatus } from "../../../common/constants";
import { AppInfo, AppPackage } from '../common/appInfo';
/**
 * 处理QQ的下载
 * 部分用了TBS等能力
 */
var QQDownloader = /** @class */ (function (_super) {
    __extends(QQDownloader, _super);
    function QQDownloader(opt) {
        var _this = this;
        var _a;
        _this = _super.call(this) || this;
        _this.name = 'QQDownloader';
        _this.opt = __assign({}, opt);
        _this.state = 0;
        var appId = opt.appId, qqAppid = opt.qqAppid, url = opt.url, packagename = opt.packagename, filename = opt.filename;
        _this.qqAppInfo = {
            appid: appId || qqAppid || ((_a = AppInfo[packagename]) === null || _a === void 0 ? void 0 : _a.qqAppid) || '',
            url: url,
            packageName: packagename,
            via: 'ANDROIDQQ.KDH5',
            appName: filename,
        };
        return _this;
    }
    QQDownloader.prototype.ready = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadJs([AppJsApi.QQ, AppJsApi.TBS])];
                    case 1:
                        _a.sent();
                        this.regAdStat();
                        return [2 /*return*/];
                }
            });
        });
    };
    QQDownloader.prototype.startByIos = function () {
        var appStore = this.opt.appStore;
        window.location.href = appStore;
    };
    QQDownloader.prototype.startByQQ = function () {
        var _this = this;
        var _a, _b;
        if ((_b = (_a = window.mqq) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.downloadApp) {
            window.mqq.app.downloadApp(__assign(__assign({}, this.qqAppInfo), { actionCode: 2 }), function (data) {
                debugLogger('下载结果:', 'mqq.app.downloadApp', JSON.stringify(data));
                _this.state = data.state;
                _this.process = data.pro || 0;
            });
        }
    };
    QQDownloader.prototype.startByAndroid = function () {
        var _a, _b, _c, _d;
        var _e = this.opt, url = _e.url, reportstring = _e.reportstring, reportstring1 = _e.reportstring1, reportstring2 = _e.reportstring2, _f = _e.needautoinstall, needautoinstall = _f === void 0 ? true : _f, rest = __rest(_e, ["url", "reportstring", "reportstring1", "reportstring2", "needautoinstall"]);
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.startDownload) {
            var errorCode = window.tbs.download.startDownload(__assign({ url: url, needautoinstall: Boolean(needautoinstall) }, rest));
            if (errorCode < 0) {
                this.emit('apierror', errorCode);
                this.startByQQ();
            }
        }
        else if (Plat.isIos) {
            this.startByIos();
        }
        else if ((_d = (_c = window.mqq) === null || _c === void 0 ? void 0 : _c.app) === null || _d === void 0 ? void 0 : _d.downloadApp) {
            this.startByQQ();
        }
        else {
            errorLogger('异常:', 'tbs.download.startDownload', '无此方法');
            window.location.href = url;
        }
    };
    QQDownloader.prototype.start = function () {
        if (Plat.isIos) {
            this.startByIos();
        }
        else {
            this.startByAndroid();
        }
    };
    /**
        * 补充内核统计上报
        *  type 上报的环节(0:下载开始;1:下载结束;2:安装完成)
        */
    QQDownloader.prototype.regAdStat = function () {
        var _a, _b;
        var _c = this.opt, url = _c.url, reportstring = _c.reportstring, reportstring1 = _c.reportstring1, reportstring2 = _c.reportstring2;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.ad) === null || _b === void 0 ? void 0 : _b.reportMsgByURL) {
            window.tbs.ad.reportMsgByURL({
                'appUrl': url,
                'type': '0',
                'reportUrl': reportstring,
            });
            window.tbs.ad.reportMsgByURL({
                'appUrl': url,
                'type': '1',
                'reportUrl': reportstring1,
            });
            window.tbs.ad.reportMsgByURL({
                'appUrl': url,
                'type': '2',
                'reportUrl': reportstring2,
            });
        }
        else {
            errorLogger('异常:', 'tbs.ad.reportMsgByURL', '无此方法');
        }
    };
    QQDownloader.prototype.pause = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var url = this.opt.url;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.pauseDownload) {
            window.tbs.download.pauseDownload({ url: url });
        }
        else if ((_d = (_c = window.mqq) === null || _c === void 0 ? void 0 : _c.app) === null || _d === void 0 ? void 0 : _d.downloadApp) {
            window.mqq.app.downloadApp(__assign(__assign({}, this.qqAppInfo), { actionCode: 3 }), function (data) {
                debugLogger('重新下载结果:', 'mqq.app.downloadApp', JSON.stringify(data));
                _this.state = data.state;
                _this.process = data.pro || 0;
            });
        }
        else if (Plat.isIos) {
            this.startByIos();
        }
        else {
            errorLogger('异常:', 'tbs.download.pauseDownload', '无此方法');
        }
    };
    QQDownloader.prototype.resume = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var url = this.opt.url;
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.resumeDownload) {
            window.tbs.download.resumeDownload({ url: url });
        }
        else if ((_d = (_c = window.mqq) === null || _c === void 0 ? void 0 : _c.app) === null || _d === void 0 ? void 0 : _d.downloadApp) {
            window.mqq.app.downloadApp(__assign(__assign({}, this.qqAppInfo), { actionCode: 2 }), function (data) {
                debugLogger('重新下载结果:', 'mqq.app.downloadApp', JSON.stringify(data));
                _this.state = data.state;
                _this.process = data.pro || 0;
            });
        }
        else if (Plat.isIos) {
            this.startByIos();
        }
        else {
            window.location.href = url;
            errorLogger('异常:', 'resumeDownload', '无此方法');
        }
    };
    QQDownloader.prototype.install = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var url = this.opt.url;
        if ((_b = (_a = window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.installApp) {
            var errorCode = window.tbs.download.installApp({ url: url }, function (res) {
                if (res === void 0) { res = {}; }
                _this.emit('install', /install:/gi.test(res.ret || ''));
            });
            if (errorCode < 0) {
                this.emit('install_error', errorCode);
                errorLogger('异常:', 'tbs.download.installApp errorCode', errorCode);
            }
        }
        else if ((_d = (_c = window.mqq) === null || _c === void 0 ? void 0 : _c.app) === null || _d === void 0 ? void 0 : _d.downloadApp) {
            window.mqq.app.downloadApp(__assign(__assign({}, this.qqAppInfo), { actionCode: 5 }), function (data) {
                debugLogger('安装结果:', 'mqq.app.downloadApp', JSON.stringify(data));
                _this.state = data.state;
                _this.process = data.process;
                if (data.state === 6) {
                    _this.emit('install', true);
                }
                else {
                    _this.emit('install_error');
                    errorLogger('安装异常:', 'mqq.app.downloadApp', data.state);
                }
            });
        }
        else if (Plat.isIos) {
            this.startByIos();
        }
        else {
            this.emit('install_error');
            errorLogger('异常:', 'tbs.download.installApp', '无此方法');
            this.startByAndroid();
        }
    };
    QQDownloader.prototype.openByOther = function () {
        var _a = this.opt, packagename = _a.packagename, active = _a.active;
        if (active) {
            location.href = active;
        }
        else {
            location.href = createDeeplink(packagename);
        }
    };
    QQDownloader.prototype.open = function () {
        var _a, _b, _c, _d;
        var _e = this.opt, packagename = _e.packagename, active = _e.active, posId = _e.posId;
        if (packagename === AppPackage.QQ) {
            return location.href = active;
        }
        if ((_b = (_a = window.tbs) === null || _a === void 0 ? void 0 : _a.package) === null || _b === void 0 ? void 0 : _b.runApp) {
            debugLogger('调起APP', 'tbs.package.runApp');
            var rst = window.tbs.package.runApp({
                packagename: packagename,
                url: active,
                PosID: posId,
                businessType: 'ug',
            }, function (res) {
                debugLogger('调起APP返回结果', 'tbs.package.runApp', res);
            });
            debugLogger('调起APP直接返回结果', 'tbs.package.runApp', rst);
        }
        else if ((_d = (_c = window.mqq) === null || _c === void 0 ? void 0 : _c.app) === null || _d === void 0 ? void 0 : _d.launchApp) {
            var app = Plat.isAndroid ? packagename : active;
            var config = Plat.isAndroid ? {} : { type: 2 };
            if (Plat.isAndroid) {
                location.href = active;
            }
            else {
                var rst = window.mqq.app.launchApp(app, config, function (res) {
                    debugLogger('调起APP返回结果', 'window.mqq.app.launchApp', res);
                    location.href = active;
                });
                debugLogger('调起APP直接返回结果', 'window.mqq.app.launchApp', rst);
            }
        }
        else {
            errorLogger('异常:', 'tbs.package.runApp/mqq.app.launchApp', '无此方法');
            this.openByOther();
        }
    };
    QQDownloader.prototype.isInstalled = function () {
        var _this = this;
        var _a = this.opt, packagename = _a.packagename, active = _a.active;
        return new Promise(function (resolve, reject) {
            var _a, _b, _c, _d, _e, _f;
            if (packagename === AppPackage.QQ) {
                resolve(true);
            }
            else if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.package) === null || _b === void 0 ? void 0 : _b.isApkInstalled) {
                var isInstalled = window.tbs.package.isApkInstalled({ packagename: packagename });
                debugLogger('判断安装结果:', 'tbs.package.isApkInstalled', Number(isInstalled) === 1);
                resolve(Number(isInstalled) === 1);
            }
            else if (Plat.isIos && ((_d = (_c = window.mqq) === null || _c === void 0 ? void 0 : _c.app) === null || _d === void 0 ? void 0 : _d.isAppInstalled)) {
                var app = Plat.isAndroid ? packagename : active;
                window.mqq.app.isAppInstalled(app, function (res) {
                    debugLogger('判断安装结果:', 'mqq.app.isAppInstalled', res.result);
                    resolve(res.result);
                });
            }
            else if (Plat.isAndroid && ((_f = (_e = window.mqq) === null || _e === void 0 ? void 0 : _e.app) === null || _f === void 0 ? void 0 : _f.checkAppInstalled)) {
                window.mqq.app.checkAppInstalled(packagename, function (res) {
                    debugLogger('判断安装结果:', 'mqq.app.checkAppInstalled', res);
                    var isInstalled = res > '0';
                    _this.state = isInstalled ? 6 : 1;
                    resolve(isInstalled);
                });
            }
            else {
                resolve(false);
                errorLogger('异常:', 'tbs.package.isApkInstalled/mqq.app.isAppInstalled', '无此方法');
            }
        });
    };
    // QQ:整个下载流程如下：下载2 --> 下载中2 --> [暂停3 --> 继续下载2] --> 下载完成4 --> 安装5 --> 安装完成6 --> [卸载完成9]
    QQDownloader.prototype.getStatus = function () {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var url, statusMap;
            return __generator(this, function (_e) {
                url = this.opt.url;
                if ((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.getDownloadStatus) {
                    return [2 /*return*/, window.tbs.download.getDownloadStatus({ url: url })];
                }
                if ((_d = (_c = window.mqq) === null || _c === void 0 ? void 0 : _c.app) === null || _d === void 0 ? void 0 : _d.downloadApp) {
                    statusMap = {
                        2: AppDownloadStatus.TASK_STATUS_PROGRESS,
                        3: AppDownloadStatus.TASK_STATUS_PROGRESS,
                        4: AppDownloadStatus.TASK_STATUS_COMPLETED,
                        5: AppDownloadStatus.TASK_STATUS_COMPLETED,
                    };
                    if (this.state > 2) {
                        return [2 /*return*/, statusMap[this.state] ? AppDownloadStatus.TASK_STATUS_COMPLETED : AppDownloadStatus.TASK_STATUS_NONE];
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    QQDownloader.prototype.getProgress = function () {
        var _this = this;
        var url = this.opt.url;
        return new Promise(function (resolve, reject) {
            var _a, _b, _c, _d, _e, _f;
            if (((_b = (_a = window === null || window === void 0 ? void 0 : window.tbs) === null || _a === void 0 ? void 0 : _a.download) === null || _b === void 0 ? void 0 : _b.getDownloadFileTotalSize) && ((_d = (_c = window === null || window === void 0 ? void 0 : window.tbs) === null || _c === void 0 ? void 0 : _c.download) === null || _d === void 0 ? void 0 : _d.getDownloadProgress)) {
                var progress = 0;
                var totalSize = window.tbs.download.getDownloadFileTotalSize({ url: url });
                if (!Number.isNaN(totalSize) && Number(totalSize) !== 0) {
                    progress = Math.floor(window.tbs.download.getDownloadProgress({ url: url }) / totalSize * 100);
                }
                resolve(progress);
            }
            else if ((_f = (_e = window.mqq) === null || _e === void 0 ? void 0 : _e.app) === null || _f === void 0 ? void 0 : _f.downloadApp) {
                var process_1 = _this.state === 4 ? 100 : _this.process || 0;
                if (process_1 === 100) {
                    _this.install();
                }
                resolve(process_1 || 0);
                debugLogger('当前进度', 'mqq.app.downloadApp', process_1);
            }
            else {
                resolve(0);
                errorLogger('异常:', 'getDownloadFileTotalSize/getDownloadProgress', '无此方法');
            }
        });
    };
    return QQDownloader;
}(EventEmitter));
export default QQDownloader;
